import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppConfig } from '@interfaces'
import { getAppConfig } from '@services'

export const getAppConfiguration = createAsyncThunk<AppConfig, boolean>(
  'getAppConfiguration',
  (isTester: boolean) => getAppConfig(isTester),
)
